// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OptionTradingStyle;
(function (OptionTradingStyle) {
    /// For non option instrument
    OptionTradingStyle[OptionTradingStyle["Undefined"] = -1] = "Undefined";
    OptionTradingStyle[OptionTradingStyle["Premium"] = 0] = "Premium";
    OptionTradingStyle[OptionTradingStyle["Futures"] = 1] = "Futures";
    OptionTradingStyle[OptionTradingStyle["MarkToMarket"] = 2] = "MarkToMarket";
})(OptionTradingStyle || (OptionTradingStyle = {}));
